<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Paieškų sąrašas') }}</h1>
    <!-- search -->
    <admin-search-list-search :loading="loading" @search="searchInstitutions" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.withdrawal_method`]="{ item }">
        <el-table-enum
          enumName="withdrawalOrderSav"
          :item="item.withdrawal_method"
        />
      </template>
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="searchListStatus" :item="item.status" />
      </template>
      <template #[`item.type`]="{ item }">
        <el-table-enum enumName="dataVolumeOrderIreg" :item="item.type" />
      </template>
      <template #[`item.criteria`]="{ item }">
        <!-- <el-table-enum enumName="StatementSearchType" :item="item.criteria" /> -->
          <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewCriteriaItem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </template>
      <template #[`item.source`]="{ item }">
        <el-table-enum enumName="searchSource" :item="item.source" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            @downloadItem="download(item)"
            @viewItem="viewItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-criteria
      v-model="showModalCriteria"
      :loading="loading"
      :item="modalCriteriaItem"
    />
  </v-container>
</template>

<script>
import AdminSearchListSearch from './AdminSearchListSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalCriteria from '@/components/modals/ModalCriteria'
import math from '@/mixins/math'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'searchList',
  components: {
    AdminSearchListSearch,
    ModalDelete,
    ModalCriteria,
  },
  mixins: [userRole, math, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      showModalCriteria: false,
      modalCriteriaItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Paieškos numeris'),
          align: 'start',
          value: 'number',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Paieškos tipas'),
          align: 'start',
          value: 'type',
        },
        {
          text: this.$t('Paieškos kriterijus'),
          align: 'start',
          value: 'criteria',
        },
        {
          text: this.$t('Duomenų naudojimo tikslas'),
          align: 'start',
          value: 'purpose',
        },
        {
          text: this.$t('Paieškos šaltinis'),
          align: 'start',
          value: 'source',
        },
        {
          text: this.$t('Naudotojas'),
          align: 'start',
          value: 'searched_by_fullname',
        },
        {
          text: this.$t('Suformavimo data'),
          align: 'start',
          value: 'receive_date',
        },
        {
          text: this.$t('Duomenų gavėjas'),
          align: 'start',
          value: 'customer_fullname',
        }
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    setItemParam(item) {
      item.canView = true
      return item
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`statement-orders/my-list`, data)
        .then((res) => {
          this.listData = res.data.statementOrders
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchInstitutions(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },

    viewItem(item) {
      this.$router.push({
        name: 'adminOrderFormList',
        params: {
          id: item.id,
          list: 1,
        },
      })
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    viewCriteriaItem(item) {
      this.modalCriteriaItem = Object.assign({}, item)
      this.showModalCriteria = true
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`search-list/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
